import axios from 'axios';
import {Loading} from "element-ui";
import {baseUrl} from "../config/env";
import i18n from './../lang/i18n'
let _loadingInstance;

const server = axios.create({
  baseURL: baseUrl,
  withCredentials: false,
  timeout: 30000
})

server.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

server.interceptors.request.use(config => {
  if (config.showLoading !== false) {
    _loadingInstance = Loading.service({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.4)',
      customClass:'fontSize48 colorWhite'
    });
  }
  return config
}, error => {
  _loadingInstance && _loadingInstance.close()
  // do something with request error
  return Promise.reject(error)
})

server.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    _loadingInstance && _loadingInstance.close();
    return response
  }, error => {
    _loadingInstance && _loadingInstance.close()
    if (error.message === 'Network Error') {
      error.message = i18n.t('lang.serverErrorNotify')
    }
    return Promise.reject(error)
  })


export default server;



// WEBPACK FOOTER //
// ./src/api/request.js